export default __webpack_public_path__ + "static/wave_header-28c61a6e906cddef7cfbff56daa93afe.png";